import { getCookie } from './index'

/**
 * 解析「是否启用 webp 后缀」，并保证 SSR / 客户端 hydration 阶段输出严格一致。
 *
 * 历史背景（hydration mismatch 修复）：
 *   早期实现是「显式传入的 cookies 优先；客户端 fallback 到 document.cookie」。
 *   该行为导致绝大多数没有透传 SSR cookie 的调用方（仓库内 60+ 处）出现：
 *     - SSR: `getCookie('supportWebp', '')` → '' → URL 末尾无 .webp
 *     - Client(hydration): 读 document.cookie 的 `supportWebp=true` → URL 末尾有 .webp
 *   两端 src 不一致，触发 [Vue warn] Hydration attribute mismatch on <img>。
 *
 * 现行约定（务必同步更新所有调用方时遵守）：
 *   - 调用方未透传 `cookies` → 一律视为「不启用 webp」，SSR / Client 输出完全一致；
 *   - 调用方显式透传 `pageContext?.headers?.cookie` → 才按 cookie 判定是否使用 webp，
 *     此时 SSR / Client 都用同一份 pageContext，结果天然一致。
 *
 * 不要直接复用 share/utils 的 `getCookie`：它在客户端会回退到 document.cookie，
 * 与 SSR 行为不对称，会再次引入 hydration mismatch。
 */
const isSupportWebp = (cookies?: string): boolean => {
  if (!cookies) return false
  return getCookie('supportWebp', cookies) === 'true'
}

// 文本书书封 ssr的cookie通过传递
export const getBookCover = (
  bookId: number | string,
  size = 180,
  cookies?: string, // 直出使用：SSR 调用方需透传 pageContext.headers.cookie 才会拼 .webp
): string => {
  const supportWebp = isSupportWebp(cookies) ? '.webp' : ''
  return `//bookcover.yuewen.com/qdbimg/349573/${bookId}/${size}${supportWebp}`
}

// 听书书封 1:1
export const getAudioCover = (
  bookId: number | string,
  size?: number,
  cookies?: string, // 直出使用：SSR 调用方需透传 pageContext.headers.cookie 才会拼 .webp
): string => {
  const supportWebp = isSupportWebp(cookies) ? '.webp' : ''
  return `https://bookcover.yuewen.com/qdbimg/349573/s_${bookId}/${
    size || 180
  }${supportWebp}`
}

export const domains = {
  m:
    import.meta.env.VITE_ENV_TYPE === 'pro'
      ? `//m.qidian.com`
      : `//${import.meta.env.VITE_API_ENV}m.qidian.com`,
  pc:
    import.meta.env.VITE_ENV_TYPE === 'pro'
      ? `//www.qidian.com`
      : `//${import.meta.env.VITE_API_ENV}www.qidian.com`,
  pcBook:
    import.meta.env.VITE_ENV_TYPE === 'pro'
      ? `//www.qidian.com`
      : `//${import.meta.env.VITE_API_ENV}www.qidian.com`,
}

/**
 * 拓展方法加载器入口
 * Author:yangye
 * @param mePreFix
 * @returns {string}
 */
export const mePreFix = (envType: string): string => {
  if (envType === 'pro') {
    return '//my.qidian.com'
  } else if (envType === 'pre' || envType === 'local') {
    return '//premy.qidian.com'
  }
  return '//oamy.qidian.com'
}
